<div class="d-flex align-items-center" mat-dialog-title>
    <div class="spacer title">Bestellijst asfalt genereren</div>
    <div>
        <button (click)="close()" mat-icon-button tabindex="-1"><i class="fas fa-times"></i></button>
    </div>
</div>
<div mat-dialog-content>
    @if (!planning) {
        <div>
            <h2>Kies een week</h2>
            <table class="table table-bordered table-striped text-right">
                <thead>
                    <tr>
                        <th class="text-center" width="70">Week</th>
                        <th>Van</th>
                        <th>Tot</th>
                    </tr>
                </thead>
                @for (week of weeks; track week) {
                    <tr class="curpoint" (click)="chooseMill(week)">
                        <td class="text-center">{{ week.startDate | date: 'w' }}</td>
                        <td>
                            {{ week.startDate | date: 'EEE dd MMM y' }}
                        </td>
                        <td>
                            {{ week.endDate | date: 'EEE dd MMM y' }}
                        </td>
                    </tr>
                }
            </table>
            <i>Het is vandaag {{ today | date: 'EEEE dd MMMM y' }}</i>
        </div>
    } @else if (planning) {
        <div>
            <h1>
                Asfaltlijst week {{ selectedWeek.startDate | date: 'w' }}
                <small
                    ><i
                        >{{ selectedWeek.startDate | date: 'dd MMM' }} -
                        {{ selectedWeek.endDate | date: 'dd MMM y' }}</i
                    ></small
                >
            </h1>
            <h3>Kies een molen</h3>
            <table class="table table-bordered table-striped table-hover">
                <thead>
                    <tr>
                        <th>Asfaltmolen</th>
                        <th class="text-right">Bestellingen</th>
                        <th class="text-right">Totaal tonnage</th>
                        <th width="50"></th>
                        <th width="50"></th>
                    </tr>
                </thead>
                @for (mill of mills; track mill) {
                    <tr class="curpoint">
                        <td>{{ mill.name }}</td>
                        <td class="text-right">{{ orders.get(mill.id)?.orderCount || '-' }}</td>
                        <td class="text-right">{{ orders.get(mill.id)?.tonsOrdered || '-' }}</td>
                        <td class="text-center" (click)="generatePdf(mill)">
                            @if (!downloadingPdf.has(mill.id) && !downloadedPdf.has(mill.id)) {
                                <i class="fas fa-file-pdf"></i>
                            }
                            @if (downloadingPdf.has(mill.id)) {
                                <i class="fas fa-spinner fa-spin"></i>
                            }
                            @if (downloadedPdf.has(mill.id) && !downloadingPdf.has(mill.id)) {
                                <i class="fas fa-check"></i>
                            }
                        </td>
                        <td class="text-center" (click)="generateCsv(mill)">
                            @if (!downloadingCsv.has(mill.id) && !downloadedCsv.has(mill.id)) {
                                <i class="fas fa-file-excel"></i>
                            }
                            @if (downloadingCsv.has(mill.id)) {
                                <i class="fas fa-spinner fa-spin"></i>
                            }
                            @if (downloadedCsv.has(mill.id) && !downloadingCsv.has(mill.id)) {
                                <i class="fas fa-check"></i>
                            }
                        </td>
                    </tr>
                }
            </table>
            <br /><br />
            <a class="curpoint" (click)="otherWeek()">&laquo; Kies een andere week</a>
        </div>
    }
</div>
